<template>
  <section id="faq" v-track-visibility.once class="faq">
    <div class="faq-container">
      <h2 class="faq-title">Veelgestelde vragen</h2>
      <div
        v-for="(item, index) in faqItems"
        :id="'faq-item-' + item.id"
        :key="item.id"
        v-track-click
        class="faq-item"
        :class="{ 'is-open': activeIndex === index }"
      >
        <button class="faq-question" @click="toggleItem(index)">
          <span>{{ item.question }}</span>
          <TIcon
            class="faq-icon"
            :class="{ 'is-open': activeIndex === index }"
            :size="32"
            :icon="mdiChevronDown"
          />
        </button>

        <transition name="slide-fade">
          <div v-show="activeIndex === index" class="faq-answer-wrapper">
            <div class="faq-answer">
              {{ item.answer }}
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div class="faq-buttons">
      <t-btn
        id="openFaqSurvey"
        class="faq__survey-btn"
        @click="onOpenFaqSurveyClick"
      >
        Andere vragen?
      </t-btn>

      <t-btn-link id="enterFormFaq" class="faq__form-btn" :to="enterFormPath">
        Vind je makelaar
      </t-btn-link>
    </div>
  </section>
</template>

<script>
import { mdiChevronDown } from '@mdi/js'
import TIcon from 'chimera/all/components/elements/TIcon.vue'

export default {
  name: 'FaqAccordionPD8337',

  components: {
    TIcon,
  },

  props: {
    enterFormPath: {
      type: String,
      required: true,
    },

    faqItems: {
      type: Array,
      required: true,
      default: () => [
        {
          id: 1,
          question: 'Example Question',
          answer: 'Example Answer',
        },
      ],
    },
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      mdiChevronDown,
      activeIndex: null,
      surveyUrl: 'https://feedback.bambelo.com/t/3oxZg65rWSus',
    }
  },

  methods: {
    /**
     * @param {MouseEvent} event
     */
    onOpenFaqSurveyClick(event) {
      event.preventDefault()
      window.open(this.surveyUrl, '_blank')
    },

    /**
     * @param {number} index
     */
    toggleItem(index) {
      this.activeIndex = this.activeIndex === index ? null : index
    },
  },
}
</script>

<style lang="scss" scoped>
.faq {
  background: linear-gradient(180deg, #c1062b 0%, #ec6446 100%);
  @apply py-20 md:py-24;
}

.faq-container {
  @apply md:max-w-4xl mx-auto px-4 container;
}

.faq-title {
  @apply text-4xl font-bold mb-6 text-white;
}

.faq-question {
  @apply flex justify-between items-center w-full py-4 text-left text-lg font-bold text-white cursor-pointer border-b border-white/30 transition-colors duration-200 ease-in-out;
}

.faq-answer {
  @apply pt-4 pb-8  text-white;
}

.faq-icon {
  @apply text-white ml-3 transition-transform duration-300 ease-in-out;
}

.faq-icon.is-open {
  @apply transform rotate-180;
}

.faq-answer-wrapper {
  @apply overflow-hidden;
}

.faq-buttons {
  @apply flex justify-center space-x-4 mt-20;

  .faq__survey-btn {
    @apply border-white border-2 text-white font-bold hover:bg-white/30;
  }

  .faq__form-btn {
    @apply bg-white text-secondary font-bold hover:bg-white/80;
  }

  .faq__survey-btn,
  .faq__form-btn {
    @apply px-6 py-2 rounded-lg;
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s ease-in;
}

.slide-fade-enter,
.slide-fade-leave-to {
  @apply max-h-0 opacity-0;
}

.slide-fade-enter-to,
.slide-fade-leave {
  @apply max-h-[500px] opacity-100;
}
</style>
